import React, { Component } from 'react';
import Row from './../row'
import { iconEmpty } from './../../../../services/helper'

class Rows extends Component {
    renderRows = () => {
        if(!this.props.listShipper.length) {
            return (
                <tr className='not-shipper'>
                    <td colSpan={4}>{iconEmpty()}</td>
                </tr>
            )
        }
        return this.props.listShipper.map((e, i) => {
            return <Row     
                shipper={e}
                key={i}
                keyRow={i}
                listShipper={this.props.listShipper}
                shipper_id={e.ShipperId}
                currentShipper={this.props.currentShipper}
                handleLoading={this.props.handleLoading}
                handleCurrentShipper={this.props.handleCurrentShipper}
            />
        })
    }

    render() {
        return (
            <tbody>{this.renderRows()}</tbody>
        );
    }
}

export default Rows;


// WEBPACK FOOTER //
// ./src/containers/switch-shipper/components/rows/index.js